import { render } from "./ModalResultadoEntrega.vue?vue&type=template&id=1e21738a"
import script from "./ModalResultadoEntrega.vue?vue&type=script&lang=js"
export * from "./ModalResultadoEntrega.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__